import { type RouteRecordRaw } from 'vue-router'

const payersRoutes: Array<RouteRecordRaw> = [
  {
    path: '/settings/payers',
    name: 'payers.index',
    component: () => import('@/modules/purchasing/payers/views/PayersIndex.vue'),
    meta: {
      pageTitle: 'Payers Index',
      breadcrumbs: ['Payers']
    }
  },
  {
    path: '/settings/payers/:id',
    name: 'payers.show',
    component: () => import('@/modules/purchasing/payers/views/PayersShow.vue'),
    meta: {
      pageTitle: 'Payer Show',
      breadcrumbs: ['Payers']
    }
  },
  {
    path: '/settings/payers/create',
    name: 'payers.create',
    component: () => import('@/modules/purchasing/payers/views/PayersEdit.vue'),
    meta: {
      pageTitle: 'Payer Create',
      breadcrumbs: ['Payers']
    }
  },
  {
    path: '/settings/payers/:id/edit',
    name: 'payers.edit',
    component: () => import('@/modules/purchasing/payers/views/PayersEdit.vue'),
    meta: {
      pageTitle: 'Payer Edit',
      breadcrumbs: ['Payers']
    },
    props: true
  }
]

export default payersRoutes
